import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../base';

export class Strikes extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/strikes`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.strikes.forEach((record: any) => this.processRecord(record)))
    );
  }

  private processRecord(record: any) {
    record.price = new BigNumber(record.price);
    record.buyCallIv = new BigNumber(record.buyCallIv).fromDecimal();
    record.sellCallIv = new BigNumber(record.sellCallIv).fromDecimal();
    record.buyPutIv = new BigNumber(record.buyPutIv).fromDecimal();
    record.sellPutIv = new BigNumber(record.sellPutIv).fromDecimal();
  }
}
